import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { map, switchMap } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { UserStore } from '../stores/user.store'
import { isAssessmentSettingsPageVisible } from '../config/assessment-settings.config'

/** 可視セクションがある場合、または SUPER_ADMIN の場合にアセスメント設定へのアクセスを許可する */
export const assessmentSettingsGuard: CanActivateFn = () => {
  const router = inject(Router)
  const authService = inject(AuthService)
  const userStore = inject(UserStore)

  return authService.user$.pipe(
    switchMap(() =>
      userStore.getOneSelf({ useCache: true }).pipe(
        map((user) => {
          if (isAssessmentSettingsPageVisible(user)) {
            return true
          }
          router.navigate(['/home'])
          return false
        }),
      ),
    ),
  )
}
